import { Component } from 'opus-angular-seed-core';

@Component({
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.close()"></button>
            <h2>{{ 'changelog.Important changes in Coursy' | translate }}</h2>
        </div>
        <div class="modal-body">
            <div class="loader01 changelog-item" ng-if="vm.loading"></div>
            <div ng-if="!vm.loading">
                <div class="changelog-item" ng-repeat="(key, item) in vm.changelogs">
                    <p class="meta" ng-if="vm.getFormattedDate(item.releasedAt) !== vm.getFormattedDate(vm.changelogs[key-1].releasedAt)">
                        {{ vm.getFormattedDate(item.releasedAt) }}
                    </p>
                    <h3>{{ item.activeI18n.title }}</h3>
                    <p ng-bind-html="item.activeI18n.content"></p>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <ul class="actions01">
                <li class="primary"><button class="btn main" type="button" ng-click="vm.close()">{{ 'general.Ok' | translate }}</button></li>
            </ul>
        </div>
    `,
    bindings: { close: '=' }
})
export default class {
    constructor (lodash, DATATABLES, ReleaseNoteResource, MomentService) {
        this.ReleaseNoteResource = ReleaseNoteResource;
        this.MomentService = MomentService;
        this.tableOptions = lodash.merge({}, DATATABLES, {
            info: false,
            ordering: false,
            paging: false
        });
        this.loading = true;
        this.changelogs = [];
    }

    $onInit () {
        this.ReleaseNoteResource.getChangelogs({ expand: 'activeI18n' }).$promise.
        then((response) => {
            this.changelogs = response;
        }).finally(() => {
            this.loading = false;
        });
    }

    getFormattedDate (timestamp) {
        return this.MomentService.formatTimeStamp(timestamp, 'MMMM DD');
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/changelog/index.js